import { getI18nPropertyValue, isEn } from '@/i18n'
import { openNewBrowserWindowByUrl, deviceType } from '@/utils/common'
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import _ from 'lodash'
import { DEFAULT_TIME_ZONE, INTERVIEW_CANCELED_STATUS, INTERVIEW_OPERATION_TYPE, INTERVIEW_STATUS, INTERVIEW_TIME_TYPE, INTERVIEW_TYPE_ONLINE_TEAMS_MEETING } from '@/constant/interview'
import { HM_MOBILE_DASHBOARD_PATH, HM_PC_DASHBOARD_PATH } from '@/constant/common'
import hmMixin from '@/views/hm/common/mixin'

let vid = 0

export default {
  mixins: [hmMixin],
  data () {
    return {
      INTERVIEW_STATUS,
      i18nPrefix: 'hm.interviewInvitation',
      loading: false,
      timeZone: DEFAULT_TIME_ZONE,
      dialog: {
        show: false,
        loading: false
      },
      // 时区列表
      timeZoneList: [],
      // 面试时长
      duration: {},
      // 当前选择的日期
      selectedDate: null,
      // 已选择的面试时间
      selectedDateTimeList: [],
      // 当前日期下hm闲忙时间
      hmScheduleList: [],
      // 已经加载的hm闲忙时间段
      hasLoadScheduleDateDurationList: [],
      // 面试官列表
      interviewerList: [],
      // 候选人列表
      candidateList: [],
      // 已选择的面试时间段
      availableInterviewTimeList: [],
      // 当前HM面试状态
      interviewStatus: null,
      // 全局面试状态
      globalInterviewStatus: null,
      // 面试时间类型 是否是单个候选人+单个hm+automatic模式（由hm作为面试组织者选择面试时间）
      interviewTimeType: null,
      // 面试组织者
      organizer: null,
      // 职位信息
      jobInfo: null,
      // 公司信息
      companyInfo: null,
      // 已确认的面试时间
      interviewedTime: null,
      // 面试类型
      interviewType: null,
      // 是否是teams会议
      isTeamsMeeting: false,
      // Teams会议链接
      teamsMeetingUrl: null,
      teamsMeetingId: null,
      teamsMeetingPassword: null,
      // microsoft graph事件
      microsoftGraphEventInfo: {
        oldMicrosoftGraphEventId: null,
        newMicrosoftGraphEventId: null
      },
      hasMicrosoftGraphAuthToken: false,
      microsoftGraphAuthUrl: null,
      // 重新预约
      reschedule: false,
      // 职位id
      jobId: null,
      hasCleanHmScheduleEmailList: []
    }
  },
  computed: {
    hasViewHiringManagerAvailabilityPremium () {
      return _.includes(this.hmInfo.permissions, 'PREMIUM_VIEW_HIRING_MANAGER_AVAILABILITY')
    },
    interviewUuid () {
      return this.$route.query.uuid
    },
    durationMinutes () {
      return this.duration.hour * 60 + this.duration.minute
    },
    selectedDateList () {
      return this.selectedDateTimeList.map(dateTime => {
        return moment(dateTime.dateTime).format('YYYY-MM-DD')
      })
    },
    isAutomaticInterview () {
      return this.interviewTimeType === INTERVIEW_TIME_TYPE.AUTOMATIC
    },
    isHmSelectInterviewTime () {
      return (this.isAutomaticInterview && this.interviewStatus === INTERVIEW_STATUS.PENDING_HM_SELECT_TIME) || this.reschedule
    },
    isCandidateSelectInterviewTime () {
      return this.isAutomaticInterview && this.interviewStatus === INTERVIEW_STATUS.PENDING_CANDIDATE_SELECT_TIME
    },
    isSuggestNewTime () {
      return this.interviewStatus === INTERVIEW_STATUS.RESCHEDULING_BY_CANDIDATE ||
        this.interviewStatus === INTERVIEW_STATUS.RESCHEDULING_BY_INTERVIEWER
    },
    showScheduleBtn () {
      return this.interviewStatus !== INTERVIEW_STATUS.PENDING_HM_SELECT_TIME && !this.reschedule
    },
    isInterviewCanceled () {
      return _.includes(INTERVIEW_CANCELED_STATUS, this.interviewStatus)
    },
    isInterviewScheduled () {
      return _.includes([INTERVIEW_STATUS.SCHEDULED, INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_URL, INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_EVENT, INTERVIEW_STATUS.PENDING], this.interviewStatus)
    },
    hiddenBtn () {
      return this.isInterviewCanceled
    },
    showAvailableInterviewTime () {
      return !this.interviewedTime || (this.interviewedTime && _.includes([INTERVIEW_STATUS.RESCHEDULING_BY_INTERVIEWER, INTERVIEW_STATUS.PENDING_CANDIDATE_SELECT_TIME], this.interviewStatus))
    },
    interviewTimeLabel () {
      if (!this.interviewedTime && this.isCandidateSelectInterviewTime) {
        return this.$t(`${this.i18nPrefix}.label.interviewTime`)
      } else if (this.interviewStatus === INTERVIEW_STATUS.RESCHEDULING_BY_CANDIDATE) {
        return this.$t(`${this.i18nPrefix}.label.reschedulingByCandidate`)
      } else if (_.includes([INTERVIEW_STATUS.RESCHEDULING_BY_INTERVIEWER, INTERVIEW_STATUS.PENDING_CANDIDATE_SELECT_TIME], this.interviewStatus)) {
        return this.$t(`${this.i18nPrefix}.label.reschedulingByInterviewer`)
      }
    },
    interviewInfoList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.label.company`),
          value: this.companyInfo?.name
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.job`),
          value: this.jobInfo?.title
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.organizer`),
          value: this.organizer?.full_name
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.interviewer`),
          value: _.chain(this.interviewerList)
            .map('full_name')
            .join(', ')
            .value()
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.candidate`),
          value: _.chain(this.candidateList)
            .map('name')
            .join(', ')
            .value()
        },
        {
          hidden: !this.interviewStatus || this.interviewStatus === INTERVIEW_STATUS.PENDING_HM_SELECT_TIME,
          label: this.$t(`${this.i18nPrefix}.label.status`),
          value: this.$t(`admin.application.candidate.label.${_.findKey(INTERVIEW_STATUS, value => value === this.interviewStatus)}`)
        }
      ]
      return _.filter(list, item => !item.hidden)
    },
    isMultipleInterviewer () {
      return this.interviewerList.length > 1
    },
    isMultipleCandidate () {
      return this.candidateList.length > 1
    },
    isHmSuggestNewTime () {
      return this.isMultipleCandidate || this.isMultipleInterviewer
    },
    maxSelectScheduleCount () {
      return this.candidateList.length > 1 ? 1 : 3
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('common', ['getTimeZoneList']),
    ...mapActions('hm', [
      'getInterviewRecordInfo',
      'updateInterviewRecordInfo',
      'updateInterviewRecordOnlineInfo',
      'getScheduleList',
      'hmCheckMicrosoftGraphAuth',
      'hmCreateOnlineMeetingEvent',
      'hmUpdateOnlineMeetingEvent',
      'hmDeleteOnlineMeetingEvent'
    ]),
    async initData () {
      this.loading = true
      try {
        this.selectedDate = moment().format('YYYY-MM-DD')
        this.duration = {
          hour: 1,
          minute: 0
        }
        await this.initHmInfo()
        await Promise.all([
          this.loadHmInterviewRecordInfo(),
          this.loadTimeZoneList()
        ])
      } finally {
        this.loading = false
      }
    },
    async loadHmInterviewRecordInfo (showLoading) {
      if (!this.interviewUuid) {
        return
      }
      if (showLoading) {
        this.loading = true
      }
      try {
        const resp = await this.getInterviewRecordInfo({ interviewUuid: this.interviewUuid })
        if (resp) {
          this.organizer = resp.creator
          this.interviewerList = resp.hire_manager
          this.candidateList = resp.candidate
          this.jobInfo = {
            id: resp.job_id,
            get title () {
              return getI18nPropertyValue(resp, 'job_cn_title', 'job_title')
            }
          }
          this.companyInfo = {
            id: resp.company_id,
            get name () {
              return getI18nPropertyValue(resp, 'company_cn_name', 'company_name')
            },
            root_company_id: resp.root_company_id
          }
          if (resp.interview_time) {
            this.interviewedTime = {
              startDateTime: moment(resp.interview_time),
              startDate: moment(resp.interview_time).format('YYYY-MM-DD'),
              startTime: moment(resp.interview_time).format('HH:mm'),
              endDateTime: moment(resp.interview_end_time),
              endDate: moment(resp.interview_end_time).format('YYYY-MM-DD'),
              endTime: moment(resp.interview_end_time).format('HH:mm')
            }
          }
          this.interviewTimeType = resp.interview_time_type
          this.interviewType = resp.interview_type
          this.isTeamsMeeting = resp.is_teams_meeting
          this.microsoftGraphEventInfo.oldMicrosoftGraphEventId = resp.microsoft_graph_event_id
          this.jobId = resp.job_id
          const currentInterviewerRecord = _.find(this.interviewerList, item => item.email_address === this.hmInfo.email_address)
          // if (!currentInterviewerRecord) {
          //   this.$router.push('/error/404.html')
          // }
          this.availableInterviewTimeList = currentInterviewerRecord.available_interview_time_list
          this.interviewStatus = currentInterviewerRecord.record_status
          this.globalInterviewStatus = resp.status

          if (_.includes([INTERVIEW_STATUS.FINISHED, INTERVIEW_STATUS.PARTIALLY_RATED], this.interviewStatus)) {
            this.$router.push(`/v-admin/hm/interview/${this.interviewUuid}?company_id=${this.companyInfo.root_company_id}`)
          }
          if ((this.interviewStatus === INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_URL || this.interviewStatus === INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_EVENT || this.hasViewHiringManagerAvailabilityPremium) && deviceType.isPc) {
            await this.checkCurrentAccountAuthGraph()
          }
          this.loadHmScheduleList(this.selectedDate)
        }
      } finally {
        if (showLoading) {
          this.loading = false
        }
      }
    },
    async handleConfirm () {
      if (_.isEmpty(this.selectedDateTimeList)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectInterviewTime`))
        return
      }
      let valid = true
      _.forEach(this.$refs.interviewDateTimeRange, (item) => {
        const itemValid = item.submit()
        if (!itemValid) {
          valid = false
        }
      })
      valid = this.checkSelectedDateTimeDuplicate()
      if (!valid) {
        return
      }
      if (this.loading) {
        return
      }
      const params = {
        interviewUuid: this.interviewUuid,
        data: {
          operation_type: INTERVIEW_OPERATION_TYPE.HM_SELECT_TIME,
          available_interview_time_list: _.map(this.selectedDateTimeList, item => {
            const startTime = moment(item.time, 'HH:mm')
            return {
              startDate: item.date,
              startTime: startTime.clone().format('HH:mm:ss'),
              endTime: startTime.add(this.durationMinutes, 'minutes').format('HH:mm:ss')
            }
          }),
          timezone: this.timeZone
        }
      }
      this.loading = true
      try {
        const resp = await this.updateInterviewRecordInfo(params)
        if (resp) {
          this.goHmDashboard()
          if (this.isHmSuggestNewTime) {
            this.$message.success({
              message: this.$t(`${this.i18nPrefix}.message.pendingHrConfirm`),
              duration: 5000
            })
          } else {
            this.$message.success({
              message: this.$t(`${this.i18nPrefix}.message.confirmSuccess`),
              duration: 5000
            })
          }
        }
      } finally {
        this.loading = false
      }
    },
    async handleSend () {
      const isPendingEvent = this.interviewStatus === INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_EVENT
      const isPendingUrl = this.interviewStatus === INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_URL
      if ((!isPendingUrl && !isPendingEvent) || !this.isAutomaticInterview) {
        return
      }
      if (!deviceType.isPc) {
        this.$message.info(this.$t(`${this.i18nPrefix}.message.placeChangePC`))
        return
      }
      if (!this.hasMicrosoftGraphAuthToken) {
        await this.checkCurrentAccountAuthGraph()
        return
      }
      await this.createOrUpdateMicrosoftMeeting()
      const needOnlineInfo = !isPendingEvent || this.isTeamsMeeting
      const onlineInfo = needOnlineInfo ? { provider: 'teams', url: this.teamsMeetingUrl, meeting_id: this.teamsMeetingId, meeting_password: this.teamsMeetingPassword } : null
      const params = {
        interviewUuid: this.interviewUuid,
        data: {
          online_info: onlineInfo,
          new_microsoft_graph_event_id: this.microsoftGraphEventInfo.newMicrosoftGraphEventId,
          old_microsoft_graph_event_id: this.microsoftGraphEventInfo.oldMicrosoftGraphEventId
        }
      }
      this.loading = true
      try {
        const resp = await this.updateInterviewRecordOnlineInfo(params)
        if (resp) {
          this.goHmDashboard()
          this.$message.success({
            message: this.$t(`${this.i18nPrefix}.message.sendSuccess`),
            duration: 5000
          })
        }
      } finally {
        this.loading = false
      }
    },
    async createOrUpdateMicrosoftMeeting () {
      if (!this.hasMicrosoftGraphAuthToken) {
        await this.checkCurrentAccountAuthGraph()
      }

      const startDateTime = `${this.interviewedTime.startDate} ${this.interviewedTime.startTime}`
      const endDateTime = `${this.interviewedTime.endDate} ${this.interviewedTime.endTime}`

      const isOnlineMeeting = this.interviewType === INTERVIEW_TYPE_ONLINE_TEAMS_MEETING

      const params = {
        start_date_time: startDateTime,
        end_date_time: endDateTime,
        timezone: this.timeZone,
        hire_managers: [
          {
            email: this.hmInfo.email_address,
            first_name: this.hmInfo.first_name,
            last_name: this.hmInfo.last_name
          }
        ],
        candidate_ids: _.map(this.candidateList, item => item.id),
        job_id: this.jobId,
        is_online_meeting: isOnlineMeeting
      }
      let resp = null
      this.loading = true
      try {
        if (this.microsoftGraphEventInfo.newMicrosoftGraphEventId) {
          await this.hmDeleteOnlineMeetingEvent({ eventId: this.microsoftGraphEventInfo.newMicrosoftGraphEventId })
        }
        if (this.microsoftGraphEventInfo.oldMicrosoftGraphEventId) {
          params.microsoft_graph_event_id = this.microsoftGraphEventInfo.oldMicrosoftGraphEventId
          resp = await this.hmUpdateOnlineMeetingEvent(params)
          this.microsoftGraphEventInfo.oldMicrosoftGraphEventId = null
        } else {
          resp = await this.hmCreateOnlineMeetingEvent(params)
        }
        if (resp) {
          const eventId = resp.id
          this.microsoftGraphEventInfo.newMicrosoftGraphEventId = eventId
          const meetingInfo = resp.meeting_info
          if (meetingInfo) {
            this.teamsMeetingUrl = meetingInfo.online_meeting?.joinUrl || ''
            this.teamsMeetingId = meetingInfo.meeting_id || ''
            this.teamsMeetingPassword = meetingInfo.passcode || ''
          }
        }
      } finally {
        this.loading = false
      }
    },
    async checkCurrentAccountAuthGraph () {
      if (this.hasMicrosoftGraphAuthToken || (this.microsoftGraphAuthWin && this.microsoftGraphAuthWin.closed)) {
        this.microsoftGraphAuthWin = null
        this.microsoftGraphAuthUrl = null
        return
      }
      const resp = await this.hmCheckMicrosoftGraphAuth()
      if (resp) {
        this.hasMicrosoftGraphAuthToken = false
        if (!this.microsoftGraphAuthUrl) {
          this.microsoftGraphAuthUrl = resp
          this.microsoftGraphAuthWin = openNewBrowserWindowByUrl(this.microsoftGraphAuthUrl, null, 500, 600)
        }
        setTimeout(this.checkCurrentAccountAuthGraph, 1000)
      } else {
        this.microsoftGraphAuthUrl = null
        this.hasMicrosoftGraphAuthToken = true
        if (this.microsoftGraphAuthWin) {
          this.microsoftGraphAuthWin.close()
        }
        this.hmScheduleList = []
        this.hasLoadScheduleDateDurationList = []
        this.loadHmScheduleList(this.selectedDate)
      }
    },
    handleCancelInterview () {
      if (this.reschedule) {
        this.reschedule = false
        return
      }
      this.dialog.show = true
    },
    async confirmCancelInterview () {
      const isTeamsInterview = this.isAutomaticInterview && this.microsoftGraphEventInfo.oldMicrosoftGraphEventId
      if (isTeamsInterview && !deviceType.isPc) {
        this.$message.info(this.$t(`${this.i18nPrefix}.message.placeChangePC`))
        return
      }
      if (isTeamsInterview && !this.hasMicrosoftGraphAuthToken) {
        this.checkCurrentAccountAuthGraph()
        return
      }
      this.dialog.loading = true
      try {
        const resp = await this.updateInterviewRecordInfo({
          interviewUuid: this.interviewUuid,
          data: {
            operation_type: INTERVIEW_OPERATION_TYPE.CANCEL
          }
        })
        if (resp) {
          if (isTeamsInterview) {
            await this.hmDeleteOnlineMeetingEvent({ eventId: this.microsoftGraphEventInfo.oldMicrosoftGraphEventId })
          }
          this.dialog.show = false
          this.goHmDashboard()
          this.$message.success({
            message: this.$t(`${this.i18nPrefix}.message.cancelSuccess`),
            duration: 5000
          })
          this.loadHmInterviewRecordInfo(true)
        }
      } finally {
        this.dialog.loading = false
      }
    },
    async handleReschedule () {
      if (!this.interviewedTime) {
        this.selectedDateTimeList = _.map(this.availableInterviewTimeList, (time, index) => {
          const startDate = moment(time.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          const startTime = moment(time.startTime, 'HH:mm:ss').format('HH:mm')
          return {
            vid: `old-${index}`,
            date: startDate,
            time: startTime,
            dateTime: `${startDate} ${startTime}`,
            duplicate: false
          }
        })
      } else {
        this.selectedDateTimeList = [
          {
            vid: 'old-0',
            date: this.interviewedTime.startDate,
            time: this.interviewedTime.startTime,
            dateTime: `${this.interviewedTime.startDate} ${this.interviewedTime.startTime}`,
            duplicate: false
          }
        ]
      }
      this.reschedule = true
    },
    handleSelectSchedule (schedule) {
      const dateTime = {
        vid: vid,
        date: this.selectedDate,
        time: schedule.time,
        dateTime: `${this.selectedDate} ${schedule.time}`,
        duplicate: false
      }
      const index = _.findIndex(this.selectedDateTimeList, { dateTime: dateTime.dateTime })
      if (index > -1) {
        this.handleDeleteTime(index)
        return
      }
      if (this.selectedDateTimeList.length >= this.maxSelectScheduleCount) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.maxSelectScheduleCount`, { maxCount: this.maxSelectScheduleCount }))
        return
      }
      this.selectedDateTimeList.push(dateTime)
      this.selectedDateTimeList = _.sortBy(this.selectedDateTimeList, dateTime => moment(dateTime.dateTime))
      this.checkSelectedDateTimeDuplicate()
      vid = vid + 1
    },
    handleDeleteTime (index) {
      this.selectedDateTimeList.splice(index, 1)
      this.checkSelectedDateTimeDuplicate()
    },
    handleTimeRangeChange (index, dateTime) {
      this.selectedDateTimeList.splice(index, 1, dateTime)
      this.checkSelectedDateTimeDuplicate()
    },
    checkSelectedDateTimeDuplicate () {
      let valid = true
      this.selectedDateTimeList = _.map(this.selectedDateTimeList, dateTime => {
        dateTime.duplicate = false
        return dateTime
      })
      const grouped = _.groupBy(_.range(this.selectedDateTimeList.length), (index) => this.selectedDateTimeList[index].dateTime)
      const duplicates = _.pickBy(grouped, (indexes) => indexes.length > 1)
      if (!_.isEmpty(duplicates)) {
        _.forEach(duplicates, indexes => {
          _.forEach(indexes, index => {
            this.selectedDateTimeList[index].duplicate = true
          })
        })
        valid = false
      }
      return valid
    },
    handleTimezoneChange () {
      this.hmScheduleList = []
      this.hasLoadScheduleDateDurationList = []
      this.loadHmScheduleList(this.selectedDate)
    },
    async loadTimeZoneList () {
      const params = {
        lang: isEn() ? 'en' : 'zh-cn'
      }
      const resp = await this.getTimeZoneList(params)
      if (resp) {
        this.timeZoneList = resp.results
      }
    },
    async loadHmScheduleList (startDate) {
      if (!this.hasViewHiringManagerAvailabilityPremium || !this.hmInfo.email_address) {
        return
      }
      let loadMore = true
      const tempStartDate = moment(startDate).format('YYYY-MM-DD HH:mm:ss')
      _.forEach(this.hasLoadScheduleDateDurationList, item => {
        const start = item.start
        const end = item.end
        if (moment(tempStartDate).isSameOrAfter(moment(start)) && moment(tempStartDate).isSameOrBefore(moment(end))) {
          loadMore = false
          return false
        }
      })
      if (!loadMore) {
        return
      }

      const start = startDate ? moment(startDate) : moment()
      const startTime = moment(`${start.format('YYYY-MM-DD')} 00:00:00`, 'YYYY-MM-DD HH:mm:ss')
      const endTime = moment(startTime).clone().add(3, 'days').endOf('day')

      const params = {
        hm_info_list: [{
          id: this.hmInfo.id,
          email: this.hmInfo.email_address,
          first_name: this.hmInfo.first_name,
          last_name: this.hmInfo.last_name
        }],
        start_date_time: startTime.format('YYYY-MM-DD HH:mm:ss'),
        end_date_time: endTime.format('YYYY-MM-DD HH:mm:ss'),
        availability_view_interval: 60,
        timezone: this.timeZone
      }
      let hasOtherLoading = false
      if (this.loading) {
        hasOtherLoading = true
      }
      this.loading = true
      try {
        const resp = await this.getScheduleList(params)
        if (resp) {
          this.hasLoadScheduleDateDurationList.push({
            start: startTime.format('YYYY-MM-DD HH:mm:ss'),
            end: endTime.format('YYYY-MM-DD HH:mm:ss')
          })
          _.forEach(resp, (item) => {
            const email = item.email
            if (this.interviewedTime && _.find(this.interviewerList, { email_address: email }) && !_.includes(this.hasCleanHmScheduleEmailList, email)) {
              item.event_list = _.filter(item.event_list, event => {
                if (!_.includes(this.hasCleanHmScheduleEmailList, email) && moment(event.start_time).isSame(this.interviewedTime.startDateTime) && moment(event.end_time).isSame(this.interviewedTime.endDateTime)) {
                  this.hasCleanHmScheduleEmailList.push(email)
                  return false
                }
                return true
              })
            }
            const scheduleIndex = _.findIndex(this.hmScheduleList, { email })
            if (scheduleIndex !== -1) {
              item.event_list = _.concat(this.hmScheduleList[scheduleIndex].event_list, item.event_list)
              this.hmScheduleList.splice(scheduleIndex, 1, item)
            } else {
              this.hmScheduleList.push(item)
            }
          })
        }
      } finally {
        if (!hasOtherLoading) {
          this.loading = false
        }
      }
    },
    handleEndTimeClick () {
      this.$refs.interviewDuration.scrollToCenterAndHighlight()
    },
    goHmDashboard () {
      window.location.href = deviceType.isPc ? HM_PC_DASHBOARD_PATH : HM_MOBILE_DASHBOARD_PATH
    },
    formatDate (date) {
      const momentDate = moment(date, 'YYYY-MM-DD')
      return momentDate.format('dddd, MMMM DD, YYYY')
    },
    formatDateTime (data, startTime, endTime) {
      const momentStartTime = moment(`${data} ${startTime}`, 'YYYY-MM-DD HH:mm')
      const momentEndTime = moment(`${data} ${endTime}`, 'YYYY-MM-DD HH:mm')
      return `${momentStartTime.format('HH:mm')} - ${momentEndTime.format('HH:mm')}`
    }
  },
  watch: {
    selectedDate: {
      handler (value) {
        this.loadHmScheduleList(value)
      }
    },
    '$i18n.locale': {
      immediate: true,
      async handler () {
        const locale = this.$i18n.locale
        if (locale === 'en') {
          moment.locale('en')
        } else {
          moment.locale('zh-cn')
        }
        this.loading = true
        try {
          await this.loadTimeZoneList()
        } finally {
          this.loading = false
        }
      }
    }
  }
}
